import { useField } from 'formik';
import React, { useState } from 'react'
import { modeTypes } from '../constants';
import { ReadOnlyField } from '../helper';
import TextInput from '../../TextInput/TextInput';
import Button from '../../Button/Button';
import { Truncate } from '../../Truncate/Truncate';

const PermanentUrlField = ({ field, fieldWidth }) => {
  const { formFieldUid } = field;
  const [permanentUrlField, permanentUrlMeta] = useField(formFieldUid);
  const [isTypingMode, setIsTypingMode] = useState(false)
  const onAddClick = () => {
    setIsTypingMode(true)
  }
  const onDeleteClick = () => {
    setIsTypingMode(false)
    const value = ''
    permanentUrlField.onChange({ target: { value, name: formFieldUid, type: "change" } })
  }
  const onInputChange = (e) => {
    const value = field.baseUrl + e.target.value
    permanentUrlField.onChange({ target: { value, name: formFieldUid, type: "change" } })
  }
  return (isTypingMode || permanentUrlField.value?.split?.(field?.baseUrl)?.[1]
    ? <div className='asset-details-v2-fields-container__permanent-url-container__input-container' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-wrapper`}>
      <div className='asset-details-v2-fields-container__permanent-url-container__input-container__base-url'>
        <div className='asset-details-v2-fields-container__permanent-url-container__input-container__base-url__text' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-base-url-text-wrapper`}>
          <Truncate testId='cs-truncate' isResponsive={true} truncateFrom='middle'>
            {field.baseUrl}
          </Truncate>
        </div>
        <div className='asset-details-v2-fields-container__permanent-url-container__input-container__input' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-input-container`}>
          <TextInput
            placeholder={field.placeholder || ''}
            testId={`cs-asset-details-field-${field?.formFieldUid}-input`}
            version={'v2'}
            width={fieldWidth}
            value={permanentUrlField.value?.split?.(field?.baseUrl)?.[1] || ''}
            onChange={onInputChange}
          />
        </div>
      </div>
      <Button className='asset-details-v2-fields-container__permanent-url-container__delete-button' onClick={onDeleteClick} version="v2" buttonType="tertiary" size={'small'} testId={`cs-asset-details-field-${field?.formFieldUid}-delete-icon`} icon="v2-Delete" onlyIcon={true} onlyIconHoverColor="secondary" />
    </div>
    : <Button className='asset-details-v2-fields-container__permanent-url-container__add-button' onClick={onAddClick} version="v2" buttonType="tertiary" size={'small'} testId={`cs-asset-details-field-${field?.formFieldUid}-plus-icon`} icon="v2-Plus" onlyIcon={true} onlyIconHoverColor="secondary" />
  )
}

const PermanentUrl = ({ field, fieldWidth, mode }) => {

  const { formFieldUid } = field;
  const [permanentUrlField, permanentUrlMeta] = useField(formFieldUid);
  const isReadOnly = mode === modeTypes.readOnly || field.readOnly
  return (
    <div className='asset-details-v2-fields-container__permanent-url-container' data-test-id={`cs-asset-details-field-${field?.formFieldUid}-wrapper`}>
      {isReadOnly ? <ReadOnlyField width={fieldWidth} showCopyIcon={field.showCopyIcon} value={permanentUrlField.value} copyLabel={field.title} copyIconSize={'small'} testId={`cs-asset-details-field-${field?.formFieldUid}-read-only-text`} copyContent={isReadOnly ? permanentUrlField.value : ''} />
        : <PermanentUrlField field={field} fieldWidth={fieldWidth} />}
    </div>
  )
}

export default PermanentUrl